<div class="order-block">

  <div *ngIf="orderInfo" class="order-block__done-overlay">
    <div class="order-block__done">
      <button type="button" class="order-block__done-close" (click)="closeConfirmation()" aria-label="Закрыть">×</button>
      <h2 i18n="@@OrderPlaced">Заказ №{{ orderInfo.id }} оформлен.</h2>
      <div class="order-block__done-totals">
        <div class="order-block__done-total">
          <p i18n="@@Total">Итого:</p>
          <p>
            <span class="order-block__done-total-main">{{ (orderInfo.totalCost | formatPriceNumber).main }}</span><span class="order-block__done-total-cents">.{{ (orderInfo.totalCost | formatPriceNumber).cents }}</span>
            <span class="order-block__done-total-curr">&nbsp;₽</span>
          </p>
        </div>
        <div class="order-block__done-total">
          <p i18n="@@TotalWithVat">Итого с НДС:</p>
          <p>
            <span class="order-block__done-total-main">{{ (orderInfo.totalCostNds | formatPriceNumber).main }}</span><span class="order-block__done-total-cents">.{{ (orderInfo.totalCostNds | formatPriceNumber).cents }}</span>
            <span class="order-block__done-total-curr">&nbsp;₽</span>
          </p>
        </div>
      </div>
      <button nbButton status="primary" fullWidth size="large" type="button" (click)="goToOrder()" i18n="@@OpenOrder">
        Открыть заказ
      </button>
    </div>
  </div>

  <form [formGroup]="inputForm" (ngSubmit)="onSubmit()" *ngIf="!orderInfo">

    <div class="order-block__contract" *ngIf="contract">
      <nb-icon icon="person-outline" class="order-block__contract-icon"></nb-icon>
      <div class="order-block__contract-text">
        <p class="order-block__contract-name">{{ contract.header }}</p>
        <p class="order-block__contract-inn" *ngIf="contract.counterParty?.inn" i18n="@@ContractInn">
          ИНН: {{ contract.counterParty.inn }}
        </p>
      </div>
    </div>

    <p class="order-block__hint" *ngIf="!fail" i18n="@@RequestInvoiceDescription">
      Для оформления заказа выберите точку самовывоза или адрес доставки
    </p>
    <p class="alert alert-warning" *ngIf="fail" i18n="@@OrderRejected">
      Не удалось обработать заказ. Повторите попытку позже
    </p>

    <nb-radio-group formControlName="deliveryMethod"
                    class="order-block__methods"
                    (valueChange)="onDeliveryMethodChange($event)">
      <nb-radio value="2"><span i18n="@@SelfPickUp">Самовывоз</span></nb-radio>
      <nb-radio value="1"><span i18n="@@DeliveryToAddress">Доставка по адресу</span></nb-radio>
    </nb-radio-group>

    <div class="form-control-group" *ngIf="isPickup">
      <label class="label" i18n="@@SelfPickPoint">Пункт самовывоза *</label>
      <nb-select fullWidth
                 i18n-placeholder="@@ChooseAddress"
                 placeholder="Выберите адрес"
                 formControlName="pickupAddress">
        <nb-option *ngFor="let address of pickupAddresses$ | async" [value]="address.id">{{ address.header }}</nb-option>
      </nb-select>
      <p class="order-block__error" *ngIf="missingPickupAddress" i18n="@@SelfPickPointRequired">
        Выберите пункт самовывоза
      </p>
    </div>

    <div class="form-control-group" *ngIf="isDelivery">
      <label class="label" i18n="@@DeliveryAddress">Адрес доставки *</label>
      <nb-select fullWidth
                 i18n-placeholder="@@ChooseAddress"
                 placeholder="Выберите адрес"
                 formControlName="deliveryAddress"
                 [disabled]="singleAddress"
                 (selectedChange)="onDeliveryAddressChange()">
        <nb-option *ngFor="let address of deliveryAddresses$ | async" [value]="address.id">{{ address.header }}</nb-option>
      </nb-select>
      <p class="order-block__error" *ngIf="missingDeliveryAddress" i18n="@@DeliveryAddressRequired">
        Выберите адрес доставки
      </p>
    </div>

    <div class="form-control-group">
      <label class="label" i18n="@@ManagerComment">Комментарий для менеджера</label>
      <textarea fullWidth nbInput type="text" formControlName="comment"></textarea>
    </div>

    <hr class="order-block__divider">

    <div class="order-block__summary">
      <div class="order-block__row">
        <span i18n="@@Amount">Количество</span>
        <span>{{ totalAmount }}&nbsp;<span i18n="@@UnitShort">шт.</span></span>
      </div>
      <div class="order-block__row">
        <span i18n="@@WithVat">с НДС</span>
        <span>{{ (totalCostVAT | formatPriceNumber).main }}.{{ (totalCostVAT | formatPriceNumber).cents }}&nbsp;₽</span>
      </div>
      <div class="order-block__row">
        <span i18n="@@WithoutVat">без НДС</span>
        <span>{{ (totalCost | formatPriceNumber).main }}.{{ (totalCost | formatPriceNumber).cents }}&nbsp;₽</span>
      </div>
    </div>

    <div class="order-block__total">
      <span i18n="@@TotalPayable">Итого к оплате</span>
      <span class="order-block__total-value">{{ (totalCostVAT | formatPriceNumber).main }}.{{ (totalCostVAT | formatPriceNumber).cents }}&nbsp;₽</span>
    </div>

    <p class="order-block__error" *ngIf="noProducts" i18n="@@NoProductsSelected">
      Выберите товары в корзине
    </p>

    <div class="order-block__actions">
      <button *ngIf="canEdit"
              nbButton
              fullWidth
              status="primary"
              class="order-block__submit"
              type="submit"
              [nbSpinner]="submitted"
              [disabled]="submitted || !products?.length"
              i18n="@@GetAnInvoice">
        Запросить счёт
      </button>

      <button type="button" class="order-block__xls" [disabled]="!products?.length" (click)="onExportXls()">
        <nb-icon icon="download-outline"></nb-icon>
        <span i18n="@@SaveToXLS">Сохранить в XLS</span>
      </button>
    </div>
  </form>
</div>
